import {
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  IconButton,
  Radio,
  RadioGroup,
  Tab,
  Tabs,
  TextField,
  Tooltip,
} from '@material-ui/core';
import React, { useEffect, useReducer, useState } from 'react';
import './ConciergeCreate.scss';
import CancelIcon from '@material-ui/icons/Cancel';
import CustomTextField from '../../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import InfoIcon from '@mui/icons-material/Info';
import { FormControl } from '@mui/material';
import ImageUpload from '../../../../../shared/image-upload/ImageUpload';
import { formDataValidate, VALID_INTEGER } from '../../../../../utils/formUtils';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import { useDispatch } from 'react-redux';
import { fetchAllServiceReqeust } from '../../../servicesSlice';
import {
  HOUSEKEEPING_TYPE,
  conciergeServiceIconOptions,
  itemConsts,
  hoursConsts,
  SCHEDULE_STATUS_ACTIVE,
  ITEM_DATA_TYPE_OPTIONS,
} from '../../../../../constants/ServiceConstants';
import { useSelector } from 'react-redux';
import { allHotelsSelector } from '../../../../property/propertySlice';
import { conciergeCreate, conciergeUpdate } from '../../../../../utils/ServicesAPIUtils';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { KeyboardTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import LinearProgressBar from '../../../../../shared/progress-bar/Progress';
import { getProcessedImages } from '../../../../../shared/image-upload/ImageProcessor';
import CustomSelect from '../../../../../shared/form-controls/custom-select/Custom-Select';
import EditIcon from '@mui/icons-material/Edit';
import { daysSort } from '../../../../../utils/commonUtils';
import { validateHhMm } from '../../../../../utils/formUtils';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import CustomChip from '../../../../../shared/form-controls/custom-chip/Custom-Chip';
import moment from 'moment';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';
import WatchLaterIcon from '@mui/icons-material/WatchLater';
import { getPreSignedUrl } from '../../../../../utils/PropertyAPIUtils';
import { convertFileToBase64 } from '../../../../../utils/commonUtils';
import { ASSET_TYPE_PROPERTY } from '../../../../../constants/PropertyConst';
import { ASSET_URL } from '../../../../../env/Configurations';
import {
  decodeMediaKeyValue,
  renderVideos,
  renderGifs,
  toMediaContent,
  processGifsForUpload,
} from '../../../../../utils/mediaUtils';

const ConciergeCreate = (props) => {
  const { toggleDrawer, obj, hotelId, editing, showLoader = () => {} } = props;
  const [tabValue, setTabValue] = useState(0);
  const [isTabInValid, setIsTabInValid] = useState(true);
  const [rawImages, setRawImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const originalHotels = useSelector(allHotelsSelector);
  const [itemList, setitemList] = useState([]);
  const [hourList, setHourList] = useState([]);
  const [edit, setEdit] = useState(false);
  const [itemIdx, setItemIdx] = useState('');
  const [rawVideos, setRawVideos] = useState([]);
  const [rawGifs, setRawGifs] = useState([]);
  const [videoImageUrl, setVideoImageUrl] = useState('');
  const [gifImageUrl, setGifImageUrl] = useState('');
  const [hasVideoError, setHasVideoError] = useState(false);
  const [isThumbnailUploading, setIsThumbnailUploading] = useState(false);
  const [isVideoLoading, setIsVideoLoading] = useState(false);
  const [isGifLoading, setIsGifLoading] = useState(false);
  const groupId = originalHotels?.find((h) => h?.id === hotelId)?.groupId;

  const [itemsError, setItemsError] = useState({
    itemName: false,
    quantity: false,
  });
  const [itemIndex, setItemIndex] = useState('');
  const [hoursError, setHoursError] = useState({
    days: false,
    fromError: false,
    fromMessage: '',
    toError: false,
    toMessage: '',
    duplicate: false,
    allDayTime: false,
    submit: false,
  });

  const [hoursEdit, setHoursEdit] = useState(false);
  const [hourIndex, setHourIndex] = useState('');
  const [isEdit, setIsEdit] = useState(false);

  const handleTabChange = (event, newValue) => {
    if (newValue < tabValue) {
      setTabValue(newValue);
    } else {
      if (tabValue === 1) {
        if (formData.isItemActive.value === 'Active' && itemList.length === 0) {
          return;
        } else {
          setTabValue(newValue);
        }
      } else if (tabValue === 2) {
        if (hourList.length === 0) {
          return;
        } else {
          setTabValue(newValue);
        }
      } else if (validate(tabValue)) {
        setTabValue(newValue);
      }
    }
  };

  const onNextClick = () => {
    if (tabValue === 1) {
      if (formData?.isItemActive?.value === 'Active' && itemList?.length === 0) return;
      setTabValue(tabValue + 1);
      return;
    }
    if (tabValue === 2) {
      if (hourList?.length === 0) return;
      if (hoursEdit && !validateHourSchedule()) return;
      setTabValue(tabValue + 1);
      return;
    }
    if (validate(tabValue)) setTabValue(tabValue + 1);
  };

  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    code: {
      value: '',
      fieldName: 'Code',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    name: {
      value: '',
      fieldName: 'Name',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    description: {
      value: '',
      fieldName: 'Description',
      errors: {},
      validations: [],
      tab: 0,
    },
    icon: {
      value: '',
      fieldName: 'Select Icon',
      errors: {},
      validations: [],
      tab: 0,
    },
    isActive: {
      value: false,
      fieldName: '',
      errors: {},
      validations: [],
    },
    resident: {
      value: 'Resident',
      fieldName: 'resident',
      validations: [],
      tab: 0,
    },
    confirmationMessage: {
      value: '',
      fieldName: 'Message',
      errors: {},
      validations: [],
      tab: 0,
    },
    scheduleCheck: {
      immediate: false,
      today: false,
      tomorrow: false,
      custom: false,
      value: [],
      fieldName: 'scheduleCheck',
      validations: [],
      tab: 0,
    },
    maxQuantity: {
      value: 'Inactive',
      fieldName: 'maxQuantity',
      validations: [],
      tab: 0,
    },
    maxQuantityNum: {
      value: '',
      fieldName: 'Max Quantity',
      errors: {},
      validations: [VALID_INTEGER],
      tab: 0,
    },
    schedule: {
      value: 'Inactive',
      fieldName: 'schedule',
      validations: [],
      tab: 0,
    },
    customDateTime: {
      value: '',
      fieldName: 'customDateTime',
      validations: [],
      tab: 0,
    },
    isItemActive: {
      value: 'Inactive',
      fieldName: 'isitemactive',
      validations: [],
      tab: 0,
    },
    itemName: {
      value: '',
      fieldName: 'Item Name',
      errors: {},
      validations: [],
      tab: 1,
    },
    itemId: {
      value: '',
      fieldName: 'Item ID',
      errors: {},
      validations: [],
      tab: 1,
    },
    itemDescription: {
      value: '',
      fieldName: 'Description',
      errors: {},
      validations: [],
      tab: 1,
    },
    itemDataType: {
      value: '',
      fieldName: 'Type',
      errors: {},
      validations: [],
      tab: 1,
    },
    itemMaxQuantity: {
      value: '',
      fieldName: 'Max Quantity',
      errors: {},
      validations: [],
      tab: 1,
    },
    itemQuantity: {
      value: 'Inactive',
      fieldName: 'itemQuantity',
      validations: [VALID_INTEGER],
      tab: 2,
    },
    itemActive: {
      value: true,
      fieldName: 'Item Active Status',
      errors: {},
      validations: [],
      tab: 1,
    },
    availableOn: {
      value: 'EveryDay',
      fieldName: 'AvailableOn',
      validations: [],
      tab: 2,
    },
    days: {
      monday: false,
      tuesday: false,
      wednesday: false,
      thursday: false,
      friday: false,
      saturday: false,
      sunday: false,
      value: [],
      fieldName: 'days',
      validations: [],
      tab: 2,
    },
    hours: {
      value: 'EveryDay',
      fieldName: 'Hours',
      validations: [],
      tab: 2,
    },
    from: {
      value: '11:00',
      fieldName: 'From',
      errors: {},
      validations: [],
      tab: 2,
    },
    to: {
      value: '23:00',
      fieldName: 'To',
      errors: {},
      validations: [],
      tab: 2,
    },
    images: {
      value: [],
      fieldName: 'Images',
      errors: {},
      validations: [],
      tab: 3,
    },
  });
  useEffect(() => {
    if (!obj) return;

    const currFields = { ...formData };
    Object.keys(currFields).forEach((key) => {
      if (
        Object.prototype.hasOwnProperty.call(obj, key) &&
        currFields[key] &&
        typeof currFields[key] === 'object' &&
        'value' in currFields[key]
      ) {
        currFields[key].value = obj[key];
      }
    });
    currFields.images && (currFields.images.value = obj?.images || []);
    currFields.schedule.value = obj?.scheduleActive ? 'Active' : 'Inactive';
    currFields.maxQuantity.value = obj?.maxQuantityActive ? 'Active' : 'Inactive';
    currFields.customDateTime.value = obj?.customSchedule || '';
    currFields.isItemActive.value = obj?.isItemActive ? 'Active' : 'Inactive';
    currFields.maxQuantityNum.value = obj?.maxQuantity;
    currFields.resident.value = obj?.resident ? 'Resident' : 'Non-Resident';
    currFields.itemName.value = '';
    currFields.itemDescription.value = '';
    currFields.itemMaxQuantity.value = '';
    currFields.itemId.value = '';
    currFields.itemQuantity.value = 'Inactive';
    currFields.itemActive.value = true;
    currFields.itemDataType.value = '';
    currFields.scheduleCheck = {
      immediate: false,
      today: false,
      tomorrow: false,
      custom: false,
      value: [],
      fieldName: 'scheduleCheck',
      validations: [],
      tab: 0,
    };
    (obj?.schedule || []).forEach((s) => {
      const k = String(s).toLowerCase();
      currFields.scheduleCheck[k] = true;
      currFields.scheduleCheck.value.push(String(s).toUpperCase());
    });
    const hoursArr = Array.isArray(obj?.hours) ? obj.hours : [];
    const isEverydayRow = (h) =>
      h?.everyday === true ||
      (Array.isArray(h?.day) &&
        h.day.length === 2 &&
        h.day[0] === 'MONDAY' &&
        h.day[1] === 'SUNDAY');
    let availableOn = 'EveryDay';
    let hoursVal = 'EveryDay';
    let from = '11:00';
    let to = '23:00';

    if (hoursArr.length > 0) {
      const everydayRow = hoursArr.find(isEverydayRow);
      if (everydayRow) {
        availableOn = 'EveryDay';
        hoursVal = everydayRow?.allTime ? 'EveryDay' : 'Custom';
        from = everydayRow?.open || from;
        to = everydayRow?.close || to;
      } else {
        availableOn = 'Custom';
        hoursVal = 'Custom';
        const first = hoursArr[0];
        const daysField = { ...currFields.days };
        Object.keys(daysField).forEach((d) => {
          if (typeof daysField[d] === 'boolean') daysField[d] = false;
        });
        daysField.value = [];
        (first?.day || []).forEach((d) => {
          const key = d.toLowerCase();
          if (key in daysField) {
            daysField[key] = true;
            daysField.value.push(key);
          }
        });
        currFields.days = daysField;

        from = first?.open || from;
        to = first?.close || to;
      }
    }
    currFields.availableOn.value = availableOn;
    currFields.hours.value = hoursVal;
    currFields.from.value = from;
    currFields.to.value = to;
    const { Video: videoMedia, GIF: gifMedia } = decodeMediaKeyValue(obj?.mediaContent);
    const videoData = videoMedia || obj?.videos || {};
    const gifData = gifMedia || obj?.gifs || {};
    setVideoImageUrl(videoData?.imageUrl || '');
    setGifImageUrl(gifData?.imageUrl || '');
    setRawVideos(renderVideos(videoData));
    setRawGifs(renderGifs(gifData));
    setFormData(currFields);
    setitemList(obj?.items || []);
    setHourList(hoursArr);
  }, [obj]);

  useEffect(() => {
    const currField = { ...formData.itemMaxQuantity };
    currField.value = '';
    setFormData({ itemMaxQuantity: currField });
  }, [formData.itemQuantity.value]);

  const handleActiveChange = (event) => {
    const currField = { ...formData.isActive };
    currField.value = event.target.checked;
    setFormData({ isActive: currField });
  };

  const validate = (tabValue) => {
    const updatedFields = {};
    const currTabFromData = Object.fromEntries(
      Object.entries(formData).filter(([key, field]) => field.tab === tabValue),
    );

    const isValid = formDataValidate(currTabFromData, updatedFields);
    setFormData(updatedFields);
    return isValid;
  };

  const onImageListUpdated = (imgObjArr) => {
    setRawImages(imgObjArr);
  };

  const onUploadedImageRemoval = (index) => {
    const images = [...formData.images.value];
    images.splice(index, 1);
    setFormData({ images: { ...formData.images, value: images } });
  };

  const onScheduleCheckChange = (e, item) => {
    if (formData?.schedule?.value === SCHEDULE_STATUS_ACTIVE) {
      const checked = e?.target?.checked;
      const currFields = { ...formData };
      currFields.scheduleCheck[item] = checked;
      if (checked) {
        currFields?.scheduleCheck?.value?.push(item?.toUpperCase());
      } else {
        currFields.scheduleCheck.value = currFields?.scheduleCheck?.value?.filter(
          (elem) => elem?.toLowerCase() !== item,
        );
      }
      if (item === 'custom' && !checked) {
        currFields.customDateTime = {
          ...currFields?.customDateTime,
          value: '',
        };
      }
      setFormData(currFields);
    }
  };

  const onDaysCheckChange = (e, item) => {
    const currFields = { ...formData };
    currFields.days[item] = e.target.checked;
    currFields.days[item]
      ? currFields.days.value.push(item)
      : (currFields.days.value = currFields.days.value.filter((elem) => elem !== item));
    setFormData(currFields);
    setHoursError({
      ...hoursError,
      days: false,
      time: false,
      duplicate: false,
      allDayTime: false,
      submit: false,
      timeField: '',
      timeMessage: '',
      fromError: false,
      fromMessage: '',
      toError: false,
      toMessage: '',
    });
  };

  const validateHourSchedule = () => {
    const isAllTime = formData?.hours?.value === 'EveryDay';
    const isEveryDay = formData?.availableOn?.value === 'EveryDay';
    if (!isEveryDay && formData?.days?.value?.length === 0) {
      setHoursError((prev) => ({
        ...prev,
        days: true,
        fromError: false,
        fromMessage: '',
        toError: false,
        toMessage: '',
      }));
      return false;
    }

    if (isAllTime) {
      setHoursError((prev) => ({
        ...prev,
        days: false,
        fromError: false,
        fromMessage: '',
        toError: false,
        toMessage: '',
        duplicate: false,
        allDayTime: false,
      }));
      return true;
    }
    const fromInvalid = !validateHhMm(formData?.from?.value);
    const toInvalid = !validateHhMm(formData?.to?.value);
    if (fromInvalid || toInvalid) {
      setHoursError((prev) => ({
        ...prev,
        fromError: fromInvalid,
        fromMessage: fromInvalid ? 'Invalid time' : '',
        toError: toInvalid,
        toMessage: toInvalid ? 'Invalid time' : '',
        days: false,
      }));
      return false;
    }

    const selectedDays = formData?.days?.value;
    const hasConflict = selectedDays?.some((day) =>
      hourList?.some((existingHour, index) => {
        if (hoursEdit && index === hourIndex) return false;
        return existingHour?.day?.includes(day?.toUpperCase()) && existingHour?.allTime;
      }),
    );

    if (hasConflict) {
      setHoursError((prev) => ({
        ...prev,
        duplicate: true,
      }));
      return false;
    }

    setHoursError((prev) => ({
      ...prev,
      days: false,
      fromError: false,
      fromMessage: '',
      toError: false,
      toMessage: '',
      duplicate: false,
      allDayTime: false,
      submit: false,
    }));
    return true;
  };

  const onCancel = (e) => {
    toggleDrawer('', false, '');
  };

  const onChangeAvailableOn = (e) => {
    if (!hoursEdit && hourList?.length === 1 && hourList[0]?.everyday && hourList[0]?.allTime) {
      setHoursError({ ...hoursError, allDayTime: true });
      return;
    }
    const availableOn = {
      value: e?.target?.value,
      fieldName: 'availableOn',
      validations: [],
      tab: 2,
    };
    setFormData({ availableOn });
    setHoursError({
      days: false,
      time: false,
      duplicate: false,
      allDayTime: false,
      timeMessage: '',
      fromError: false,
      fromMessage: '',
      toError: false,
      toMessage: '',
    });
  };

  const onChangeHours = (e) => {
    if (!hoursEdit && hourList?.length === 1 && hourList[0]?.everyday && hourList[0]?.allTime) {
      setHoursError({ ...hoursError, allDayTime: true });
      return;
    }
    const hours = {
      value: e?.target?.value,
      fieldName: 'hours',
      validations: [],
      tab: 2,
    };
    setFormData({ hours });
    setHoursError({
      days: false,
      time: false,
      duplicate: false,
      allDayTime: false,
      timeMessage: '',
    });
  };

  const onItemQuantityChange = (e) => {
    const itemQuantity = {
      value: e.target.value,
      fieldName: 'itemQuantity',
      validations: [],
      tab: 1,
    };
    setFormData({ itemQuantity });
  };

  const onMaxQuantityChange = (e) => {
    const maxQuantity = {
      value: e.target.value,
      fieldName: 'itemQuantity',
      validations: [],
      tab: 0,
    };
    setFormData({ maxQuantity });
  };

  const onScheduleChange = (e) => {
    const schedule = {
      value: e?.target?.value,
      fieldName: 'schedule',
      validations: [],
      tab: 0,
    };
    if (e?.target?.value !== SCHEDULE_STATUS_ACTIVE) {
      const currFields = { ...formData };
      currFields.schedule = schedule;
      currFields.scheduleCheck = {
        custom: false,
        value: [],
      };
      currFields.customDateTime = {
        Date: false,
        Time: false,
        'Date & Time': false,
        value: '',
      };
      setFormData(currFields);
    } else {
      setFormData({ ...formData, schedule });
    }
  };
  const isScheduleSelectionValid = () => {
    if (formData?.schedule?.value !== SCHEDULE_STATUS_ACTIVE) return true;
    const { immediate, today, tomorrow, custom } = formData?.scheduleCheck;
    if (!immediate && !today && !tomorrow && !custom) return false;
    if (custom && !formData?.customDateTime?.value) return false;
    return true;
  };

  const onCustomDateTimeChange = (e) => {
    const customDateTime = {
      value: e.target.value,
      fieldName: 'Date & time',
      validations: [],
      tab: 0,
    };
    setFormData({ customDateTime });
  };

  const onResidentChange = (e) => {
    const resident = {
      value: e.target.value,
      fieldName: 'Resident',
      validations: [],
      tab: 0,
    };
    setFormData({ resident });
  };

  useEffect(() => {
    const itemName =
      formData.isItemActive.value === 'Active'
        ? { ...formData.itemName, validations: ['required'] }
        : { ...formData.itemName, validations: [] };
    setFormData({ itemName });
  }, [formData.isItemActive.value]);

  useEffect(() => {
    const maxQuantityNum =
      formData.maxQuantity.value === 'Active'
        ? { ...formData.maxQuantityNum, validations: ['required', VALID_INTEGER] }
        : { ...formData.maxQuantityNum, validations: [] };
    setFormData({ maxQuantityNum });
  }, [formData.maxQuantity.value]);

  const onItemActiveChange = (e) => {
    const isItemActive = { ...formData.isItemActive, value: e.target.value };
    setFormData({ isItemActive });
    const itemName =
      formData.isItemActive.value === 'Active'
        ? { ...formData.itemName, validations: [] }
        : { ...formData.itemName, validations: ['required'] };
    setFormData({ itemName });
  };

  useEffect(() => {
    if (tabValue === 2) {
      const invalid = hourList?.length === 0 || (hoursEdit && !validateHourSchedule());
      setIsTabInValid(invalid);
    } else {
      const currTabFields = Object?.fromEntries(
        Object?.entries(formData)?.filter(([, field]) => field?.tab === tabValue),
      );
      const isValid = formDataValidate(currTabFields, false);
      setIsTabInValid(!isValid);
    }
  }, [formData, tabValue, hourList, hoursEdit]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      try {
        dispatch(stepUpLoaderCount());
        const selectedLanguage = decryptLocalStorage('lang');
        const language = selectedLanguage !== 'en' ? selectedLanguage : '';
        setLoading(true);
        toggleDrawer('', false, '');
        const payload = {};
        for (let field in formData) {
          payload[field] = formData[field].value;
        }
        payload.isItemActive = formData.isItemActive.value === 'Active' ? true : false;
        payload.itemList = itemList.length > 0 ? itemList : [];
        const isEveryday = formData.availableOn.value === 'EveryDay';
        const isAllTime = formData.hours.value === 'EveryDay';
        const buildEverydayRow = () => ({
          everyday: true,
          allTime: isAllTime,
          day: ['MONDAY', 'SUNDAY'],
          open: isAllTime ? '' : formData.from.value || '',
          close: isAllTime ? '' : formData.to.value || '',
        });

        let outgoingHours;

        if (isEveryday) {
          outgoingHours = [buildEverydayRow()];
        } else if (Array.isArray(hourList) && hourList.length > 0) {
          outgoingHours = hourList;
        } else {
          const dayList = (formData.days.value || []).map((d) => d.toUpperCase());
          outgoingHours = [
            {
              everyday: false,
              allTime: isAllTime,
              day: dayList,
              open: isAllTime ? '' : formData.from.value || '',
              close: isAllTime ? '' : formData.to.value || '',
            },
          ];
        }
        payload.hours = outgoingHours;
        const gifDataArr = await processGifsForUpload({
          rawGifs,
          groupId,
          propertyType: HOUSEKEEPING_TYPE,
          hotelId,
        });
        const mediaContent = toMediaContent({
          videoList: rawVideos,
          videoImageUrl,
          gifList: gifDataArr,
          gifImageUrl,
        });
        payload.images = await getProcessedImages(
          rawImages,
          originalHotels.find((hotel) => hotel.id === hotelId).groupId,
          HOUSEKEEPING_TYPE,
          hotelId,
        );
        payload.mediaContent = mediaContent;
        payload.videos = { imageUrl: videoImageUrl || '' };
        payload.gifs = { imageUrl: gifImageUrl || '' };

        if (obj) {
          payload.id = obj.id;
          await conciergeUpdate(payload, hotelId, language);
          notificationManager('success', 'Concierge updated successfully');
        } else {
          await conciergeCreate(payload, hotelId, language);
          notificationManager('success', 'Concierge created successfully');
        }

        dispatch(fetchAllServiceReqeust(hotelId));
        setLoading(false);
      } catch (error) {
        if (error?.graphQLErrors) {
          notificationManager('danger', error?.graphQLErrors?.[0]?.message);
        } else {
          obj
            ? notificationManager('danger', 'Concierge updation failed')
            : notificationManager('danger', 'Concierge creation failed');
        }
        setLoading(false);
        setTabValue(0);
      } finally {
        dispatch(stepDownLoaderCount());
      }
    }
  };

  useEffect(() => {
    const itemMaxQuantity =
      formData.itemQuantity.value === 'Active'
        ? {
            ...formData.itemMaxQuantity,
            validations: ['required', VALID_INTEGER],
            value: edit
              ? (itemList[itemIdx]?.maxQuantity > 0 ? itemList[itemIdx]?.maxQuantity : '') ||
                (obj?.items[itemIdx]?.maxQuantity > 0 ? obj?.items[itemIdx]?.maxQuantity : '')
              : '',
          }
        : { ...formData.itemMaxQuantity, validations: [], value: '' };
    setFormData({ itemMaxQuantity });
  }, [formData.itemQuantity.value, edit, itemIdx, itemList, obj]);

  const onItemAdd = () => {
    const updateArr = [...itemList];
    if (!validate(tabValue)) return;
    if (!formData.itemName.value) {
      setItemsError({ ...itemsError, itemName: true });
      return;
    }
    if (formData.itemQuantity.value === 'Active' && formData.itemMaxQuantity.value < 1) {
      setItemsError({ ...itemsError, quantity: true });
      return;
    }

    const itemObj = {
      description: formData.itemDescription.value,
      id: formData.itemId.value,
      maxQuantity:
        formData.itemQuantity.value === 'Active' && formData.itemMaxQuantity.value
          ? parseInt(formData.itemMaxQuantity.value)
          : -1,
      maxQuantityActive: formData.itemQuantity.value === 'Active' ? true : false,
      name: formData.itemName.value,
      isActive: formData.itemActive.value,
      itemDataType: formData.itemDataType.value,
    };
    updateArr.push(itemObj);
    setitemList(updateArr);
    setItemsError({ itemName: false, quantity: false });
    onResetItem();
  };

  const onItemEdit = (event, index) => {
    setEdit(true);
    setItemIdx(index);
    event.preventDefault();
    const selectedItem = itemList[index];
    
    setFormData({
      itemName: { ...formData.itemName, value: selectedItem.name || '' },
      itemId: { ...formData.itemId, value: selectedItem.id || '' },
      itemDescription: { ...formData.itemDescription, value: selectedItem.description || '' },
      itemQuantity: { ...formData.itemQuantity, value: selectedItem.maxQuantityActive ? 'Active' : 'Inactive' },
      itemMaxQuantity: { ...formData.itemMaxQuantity, value: selectedItem.maxQuantity > 0 ? selectedItem.maxQuantity : '' },
      itemActive: { ...formData.itemActive, value: selectedItem.isActive !== undefined ? selectedItem.isActive : true },
      itemDataType: { ...formData.itemDataType, value: selectedItem.itemDataType || '' },
    });
    setItemIndex(index);
  };

  const onItemUpdate = (index) => {
    const editedArr = [...itemList];
    if (!formData.itemName.value) {
      setItemsError({ ...itemsError, itemName: true });
      return;
    }
    const itemObj = {
      name: formData.itemName.value,
      id: formData.itemId.value,
      description: formData.itemDescription.value,
      maxQuantity:
        formData.itemQuantity.value === 'Active' && formData.itemMaxQuantity.value
          ? parseInt(formData.itemMaxQuantity.value)
          : -1,
      maxQuantityActive: formData.itemQuantity.value === 'Active' ? true : false,
      isActive: formData.itemActive.value,
      itemDataType: formData.itemDataType.value,
    };
    editedArr[index] = itemObj;
    setitemList(editedArr);
    setItemsError({ itemName: false, quantity: false });
    setEdit(false);
    onResetItem();
  };

  const onDeleteItem = (event, index) => {
    event.preventDefault();
    const updatedArr = [...itemList];
    updatedArr.splice(index, 1);
    setitemList(updatedArr);
  };

  const onResetItem = () => {
    const items = itemConsts;
    items.forEach((item) => {
      const currField = { ...formData[item] };
      currField.fieldName === 'itemQuantity'
        ? (currField.value = 'Inactive')
        : (currField.value = '');
      setFormData({
        [item]: currField,
      });
    });
    setFormData({
      itemActive: { ...formData.itemActive, value: true },
    });
  };

  const cancelEdit = () => {
    setEdit(false);
    onResetItem();
  };

  const onHourAdd = () => {
    if (!validateHourSchedule()) return;
    if (
      formData?.hours?.value === 'Custom' &&
      formData?.availableOn?.value === 'Custom' &&
      formData?.days?.value?.length === 1
    ) {
      const isValid = validateCustomTime(
        formData?.from?.value,
        formData?.to?.value,
        formData?.days?.value,
      );
      if (!isValid) {
        setFormData({
          from: { ...formData?.from, errors: {} },
          to: { ...formData?.to, errors: {} },
        });
        setHoursError((prev) => ({
          ...prev,
          time: true,
          timeMessage: 'Invalid time',
          submit: true,
          fromError: false,
          fromMessage: '',
          toError: false,
          toMessage: '',
        }));
        return;
      }
    }
    const hoursUpdateArr = [...hourList];
    const itemObj = {
      allTime: formData.hours.value === 'EveryDay' ? true : false,
      close: formData.to.value ? formData.to.value : '',
      day:
        formData.availableOn.value === 'EveryDay'
          ? ['MONDAY', 'SUNDAY']
          : daysSort(formData.days.value.map((day) => day.toUpperCase())),
      everyday: formData.availableOn.value === 'EveryDay' ? true : false,
      open: formData.from.value ? formData.from.value : '',
    };
    const isFound = hourList.some((element) => {
      if (JSON.stringify(element) === JSON.stringify(itemObj)) {
        return true;
      }
      const isDuplicate = element.day.some((item) => {
        return itemObj.day.includes(item);
      });
      let startTime = moment(element.open, 'HH:mm');
      let endTime = moment(element.close, 'HH:mm');
      let openTime = moment(itemObj.open, 'HH:mm');
      let closeTime = moment(itemObj.close, 'HH:mm');
      if (
        isDuplicate &&
        (openTime.isBetween(startTime, endTime, undefined, '[]') ||
          closeTime.isBetween(startTime, endTime, undefined, '[]'))
      ) {
        return true;
      }
      if (
        isDuplicate &&
        (startTime.isBetween(openTime, closeTime, undefined, '[]') ||
          endTime.isBetween(openTime, closeTime, undefined, '[]'))
      ) {
        return true;
      }
    });
    if (isFound) {
      setHoursError({
        ...hoursError,
        days: false,
        duplicate: true,
        fromError: false,
        fromMessage: '',
        toError: false,
        toMessage: '',
      });
      return;
    }
    let next;
    if (itemObj.everyday) {
      next = [itemObj];
    } else {
      next = hoursUpdateArr.filter((h) => !h.everyday).concat(itemObj);
    }
    setHourList(next);
    setHoursError({
      ...hoursError,
      days: false,
      time: false,
      duplicate: false,
      allDayTime: false,
      submit: false,
      timeField: '',
      timeMessage: '',
      fromError: false,
      fromMessage: '',
      toError: false,
      toMessage: '',
    });
    resetHours();
    setIsEdit(false);
  };

  const onHoursEdit = (e, index, days) => {
    e.preventDefault();
    setIsEdit(true);
    setHoursEdit(true);
    const hours = hoursConsts.sort();
    const data = hourList[index];
    const keys = ['everyday', 'open', 'allTime', 'close'];

    // Reset days selection first
    const currHourField = { ...formData.days };
    Object.keys(currHourField).forEach((day) => {
      currHourField[day] = false;
    });
    currHourField.value = [];

    // Only set days if not everyday
    if (!data.everyday) {
      days.forEach((day) => {
        const dayLower = day.toLowerCase();
        if (currHourField.hasOwnProperty(dayLower)) {
          currHourField[dayLower] = true;
          currHourField.value.push(dayLower);
        }
      });
    }

    // Set other form fields
    hours.forEach((item, idx) => {
      const currTimeField = { ...formData[item] };
      if (currTimeField.fieldName === 'AvailableOn' || currTimeField.fieldName === 'availableOn') {
        currTimeField.value = data[keys[idx]] ? 'EveryDay' : 'Custom';
      } else if (currTimeField.fieldName === 'Hours' || currTimeField.fieldName === 'hours') {
        currTimeField.value = data[keys[idx]] ? 'EveryDay' : 'Custom';
      } else {
        currTimeField.value = data[keys[idx]];
      }
      setFormData({
        [item]: currTimeField,
      });
    });

    setFormData({ days: currHourField });
    setHourIndex(index);
  };

  const onUpdateHours = (index) => {
    setFormData({
      from: { ...formData.from, errors: {} },
      to: { ...formData.to, errors: {} },
    });
    if (!validateHourSchedule()) {
      return;
    }

    if (
      formData?.hours?.value === 'Custom' &&
      formData?.availableOn?.value === 'Custom' &&
      formData?.days?.value?.length === 1
    ) {
      const isValid = validateCustomTime(
        formData?.from?.value,
        formData?.to?.value,
        formData?.days?.value,
      );
      if (!isValid) {
        setFormData({
          from: { ...formData?.from, errors: {} },
          to: { ...formData?.to, errors: {} },
        });
        setHoursError((prev) => ({
          ...prev,
          time: true,
          timeMessage: 'Invalid time',
          submit: true,
          fromError: false,
          fromMessage: '',
          toError: false,
          toMessage: '',
        }));
        return;
      }
    }

    const updatedEntry = {
      allTime: formData.hours.value === 'EveryDay',
      close: formData.to.value || '',
      day: formData.days.value.map((day) => day.toUpperCase()),
      everyday: formData.availableOn.value === 'EveryDay',
      open: formData.from.value || '',
    };

    const isDuplicate = hourList.some((entry, idx) => {
      if (idx === index) return false;

      const hasSameDay = entry.day.some((d) => updatedEntry.day.includes(d));
      const startA = moment(entry.open, 'HH:mm');
      const endA = moment(entry.close, 'HH:mm');
      const startB = moment(updatedEntry.open, 'HH:mm');
      const endB = moment(updatedEntry.close, 'HH:mm');

      return (
        hasSameDay &&
        (startB.isBetween(startA, endA, undefined, '[]') ||
          endB.isBetween(startA, endA, undefined, '[]') ||
          startA.isBetween(startB, endB, undefined, '[]') ||
          endA.isBetween(startB, endB, undefined, '[]'))
      );
    });

    if (isDuplicate) {
      setHoursError({
        ...hoursError,
        duplicate: true,
        fromError: false,
        fromMessage: '',
        toError: false,
        toMessage: '',
      });
      return;
    }

    const updatedList = [...hourList];
    updatedList[index] = updatedEntry;
    setHourList(updatedList);
    setHoursError({
      ...hoursError,
      days: false,
      time: false,
      duplicate: false,
      allDayTime: false,
      submit: false,
      timeField: '',
      timeMessage: '',
      fromError: false,
      fromMessage: '',
      toError: false,
      toMessage: '',
    });
    setHoursEdit(false);
    resetHours();
    setIsEdit(false);
  };

  const onDeleteHour = (event, index) => {
    event.preventDefault();
    const hoursUpdateArr = [...hourList];
    hoursUpdateArr.splice(index, 1);
    setHourList(hoursUpdateArr);
  };

  const resetHours = () => {
    const currField = { ...formData };
    currField.days = {
      ...currField.days,
      monday: false,
      tuesday: false,
      wednesday: false,
      thursday: false,
      friday: false,
      saturday: false,
      sunday: false,
      value: [],
    };
    setFormData(currField);
  };

  const validateCustomTime = (fromTime, toTime, selectedDays) => {
    if (selectedDays?.length !== 1) return true;
    const from = moment(fromTime, 'HH:mm');
    const to = moment(toTime, 'HH:mm');
    return to.isAfter(from);
  };

  const handleTimeChange = (date, value, type) => {
    const currTimeField = { ...formData[type], value };
    const next = {
      ...formData,
      [type]: currTimeField,
    };

    const fromValid = validateHhMm(next?.from?.value);
    const toValid = validateHhMm(next?.to?.value);

    let isOrderValid = true;
    if (fromValid && toValid) {
      const customSelected = next?.availableOn?.value === 'Custom';
      const dayCount = next?.days?.value?.length || 0;

      if (customSelected && dayCount <= 1) {
        isOrderValid = moment(next?.to?.value, 'HH:mm')?.isAfter(
          moment(next?.from?.value, 'HH:mm'),
        );
      }
    }

    setHoursError((prev) => ({
      ...prev,
      fromError:
        type === 'from'
          ? !fromValid || (toValid && !isOrderValid)
          : prev?.fromError && (!fromValid || !isOrderValid),
      fromMessage:
        type === 'from' && (!fromValid || (toValid && !isOrderValid))
          ? 'Invalid time'
          : prev?.fromMessage,
      toError:
        type === 'to'
          ? !toValid || (fromValid && !isOrderValid)
          : prev?.toError && (!toValid || !isOrderValid),
      toMessage:
        type === 'to' && (!toValid || (fromValid && !isOrderValid))
          ? 'Invalid time'
          : prev?.toMessage,
      submit: false,
    }));

    setFormData({ [type]: currTimeField });
  };

  const reorder = (list, sourceIndex, destinationIndex) => {
    const result = [...list];
    const [removed] = result.splice(sourceIndex, 1);
    result.splice(destinationIndex, 0, removed);
    return result;
  };

  const onDragEnd = (dragResult) => {
    if (!dragResult.destination) return;
    const reorderedinfo = reorder(itemList, dragResult.source.index, dragResult.destination.index);
    setitemList(reorderedinfo);
  };

  const isMaxQtyValid =
    formData?.maxQuantity?.value !== 'Active' || Number(formData?.maxQuantityNum?.value) > 0;

  return (
    <div className='concierge-create'>
      <div className='container d-flex align-items-center flex-column'>
        <div className='row px-3 w-100 mt-4 align-items-center justify-content-between'>
          <div className='col-md-4'>
            <span className='page-title'>{editing ? 'Edit' : 'Add'} Service</span>
          </div>
          <div className='col-md-6 align-items-start'>
            <Tabs
              value={tabValue}
              variant='fullWidth'
              indicatorColor='primary'
              onChange={handleTabChange}
              aria-label='roomTypes-add-tabs'
              textColor='primary'
              className='property-tabs'
            >
              <Tab label='Details' />
              <Tab label='Items' />
              <Tab label='Hours' />
              <Tab label='Media' />
            </Tabs>
          </div>
          <div className='col-md-1 d-flex justify-content-end'>
            <IconButton aria-label='delete' onClick={(e) => onCancel(e)}>
              <CancelIcon />
            </IconButton>
          </div>
        </div>
        {tabValue === 0 && (
          <div className='row px-3 w-100 d-flex mt-4 mb-3 overflow-auto'>
            <h4 className='tab-title'>Details</h4>
            <div className='row'>
              <div className='col-md-6 mb-3 '>
                <CustomTextField
                  item={formData.name}
                  handleInputChange={(e) => {
                    setFormData({ name: e });
                  }}
                  maxLength='100'
                  multiline={true}
                  endAdornment={true}
                  characterCount={true}
                />
              </div>
              <div className='col-md-6 mb-3'>
                <CustomTextField
                  item={formData.code}
                  handleInputChange={(e) => {
                    setFormData({ code: e });
                  }}
                  maxLength='30'
                  endAdornment={true}
                  characterCount={true}
                />
              </div>
            </div>
            <div className='row'>
              <div className='col-md-6'>
                <CustomSelect
                  hideNullOption={false}
                  item={formData.icon}
                  handleInputChange={(e) => {
                    setFormData({ icon: e });
                  }}
                  options={conciergeServiceIconOptions}
                />
              </div>
              <div className='col-md-5 ms-2'>
                <div className='mt-3 d-flex align-items-center'>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          className='check-box'
                          checked={formData.isActive.value}
                          onChange={handleActiveChange}
                        />
                      }
                      label='Active'
                    />
                  </FormGroup>
                  <div>
                    <Tooltip
                      title='Deactivating a service hides it from Guest App'
                      placement='right'
                    >
                      <InfoIcon fontSize='small' className='ms-2' />
                    </Tooltip>
                  </div>
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='col-md-12 mb-3'>
                <CustomTextField
                  item={formData.description}
                  handleInputChange={(e) => {
                    setFormData({ description: e });
                  }}
                  multiline={true}
                />
              </div>
            </div>
            <div className='col-md-8 mt-3'>
              <div className='align-items-center'>
                <h4 className='tab-title'>Available for</h4>
                <div className='d-flex justify-content-between'>
                  <FormControl>
                    <RadioGroup
                      row
                      aria-labelledby='demo-radio-buttons-group-label'
                      defaultValue={formData.resident.value}
                      value={formData.resident.value}
                      name='radio-buttons-group'
                      onChange={(e) => onResidentChange(e)}
                    >
                      <FormControlLabel value='Resident' control={<Radio />} label='Resident' />
                      <FormControlLabel
                        value='Non-Resident'
                        control={<Radio className='radio' />}
                        label='Non-Resident'
                        className='ms-5'
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
              </div>
            </div>
            <div className='col-md-6 mt-3'>
              <div className='d-flex align-items-center'>
                <h4 className='tab-title'>Confirmation Message</h4>
                <Tooltip title='Default Message: Your request has been confirmed' placement='right'>
                  <InfoIcon fontSize='small' className='ms-4' />
                </Tooltip>
              </div>
            </div>
            <div className='row'>
              <div className='col-md-12'>
                <CustomTextField
                  item={formData.confirmationMessage}
                  handleInputChange={(e) => {
                    setFormData({ confirmationMessage: e });
                  }}
                  multiline={true}
                />
              </div>
            </div>
            <div className='col-md-6 mt-4'>
              <div className='align-items-center'>
                <h4 className='tab-title'>Max Quantity</h4>
                <div className='d-flex justify-content-between'>
                  <FormControl>
                    <RadioGroup
                      row
                      aria-labelledby='demo-radio-buttons-group-label'
                      defaultValue={formData.maxQuantity.value}
                      value={formData.maxQuantity.value}
                      name='radio-buttons-group'
                      onChange={(e) => onMaxQuantityChange(e)}
                    >
                      <FormControlLabel value='Inactive' control={<Radio />} label='Inactive' />
                      <FormControlLabel
                        value='Active'
                        control={<Radio className='radio' />}
                        label='Active'
                        className='ms-5'
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
                {formData.maxQuantity.value === 'Active' && (
                  <CustomTextField
                    item={formData.maxQuantityNum}
                    handleInputChange={(field) => {
                      const rawStr = field?.value != null ? String(field?.value) : '';
                      const cleaned = rawStr?.replace(/^0+/, '');
                      setFormData({
                        maxQuantityNum: { ...field, value: cleaned },
                      });
                    }}
                    type='number'
                    min={1}
                  />
                )}
              </div>
            </div>
            <div>
              <div className='col-md-6 mt-4'>
                <div className='align-items-center'>
                  <h4 className='tab-title'>Schedule</h4>
                  <div className='d-flex justify-content-between'>
                    <FormControl>
                      <RadioGroup
                        row
                        aria-labelledby='demo-radio-buttons-group-label'
                        defaultValue={formData.schedule.value}
                        value={formData.schedule.value}
                        name='radio-buttons-group'
                        onChange={(e) => onScheduleChange(e)}
                      >
                        <FormControlLabel value='Inactive' control={<Radio />} label='Inactive' />
                        <FormControlLabel
                          value='Active'
                          control={<Radio className='radio' />}
                          label='Active'
                          className='ms-5'
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>
                </div>
              </div>
              {formData.schedule.value === 'Active' && (
                <div>
                  <div className='d-flex justify-content-between col-7 mt-2'>
                    <FormControlLabel
                      control={
                        <Checkbox
                          className='check-box'
                          checked={formData.scheduleCheck.immediate}
                          onChange={(e) => onScheduleCheckChange(e, 'immediate')}
                        />
                      }
                      label='Immediate'
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          className='check-box'
                          checked={formData.scheduleCheck.today}
                          onChange={(e) => onScheduleCheckChange(e, 'today')}
                        />
                      }
                      label='Today'
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          className='check-box'
                          checked={formData.scheduleCheck.tomorrow}
                          onChange={(e) => onScheduleCheckChange(e, 'tomorrow')}
                        />
                      }
                      label='Tomorrow'
                    />
                  </div>
                  <div className='d-flex justify-content-between col-7 mt-2 '>
                    <FormControlLabel
                      control={
                        <Checkbox
                          className='check-box'
                          checked={formData.scheduleCheck.custom}
                          onChange={(e) => onScheduleCheckChange(e, 'custom')}
                        />
                      }
                      label='Custom'
                    />
                  </div>
                </div>
              )}
              {formData?.scheduleCheck?.custom &&
                formData?.schedule.value === SCHEDULE_STATUS_ACTIVE && (
                  <div className='col-md-8 mt-2'>
                    <div className='align-items-center'>
                      <div className='d-flex justify-content-between'>
                        <FormControl>
                          <RadioGroup
                            row
                            aria-labelledby='demo-radio-buttons-group-label'
                            defaultValue='Date & Time'
                            value={formData.customDateTime.value}
                            name='radio-buttons-group'
                            onChange={(e) => onCustomDateTimeChange(e)}
                          >
                            <FormControlLabel
                              value='Date & Time'
                              control={<Radio />}
                              label='Date & Time'
                            />
                            <FormControlLabel
                              value='Date '
                              control={<Radio className='radio' />}
                              label='Date'
                              className='ms-5'
                            />
                            <FormControlLabel
                              value='Time'
                              control={<Radio className='radio' />}
                              label='Time'
                              className='ms-5'
                            />
                          </RadioGroup>
                        </FormControl>
                      </div>
                    </div>
                  </div>
                )}
            </div>
          </div>
        )}
        {tabValue === 1 && (
          <div className='row px-3 w-100 d-flex mt-4 overflow-auto'>
            <h4 className='tab-title'>Items</h4>
            <div className='d-flex justify-content-between'>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby='demo-radio-buttons-group-label'
                  defaultValue={formData.isItemActive.value}
                  value={formData.isItemActive.value}
                  name='radio-buttons-group'
                  onChange={(e) => onItemActiveChange(e)}
                >
                  <FormControlLabel value='Active' control={<Radio />} label='Active' />
                  <FormControlLabel
                    value='Inactive'
                    control={<Radio className='radio' />}
                    label='Inactive'
                    className='ms-5'
                  />
                </RadioGroup>
              </FormControl>
            </div>
            {formData.isItemActive.value === 'Active' && (
              <div>
                <div className='row'>
                  <div className='col-md-6 mb-3 '>
                    <CustomTextField
                      item={formData.itemName}
                      handleInputChange={(e) => {
                        setFormData({ itemName: e });
                      }}
                      maxLength='100'
                      multiline={true}
                      endAdornment={true}
                      characterCount={true}
                    />
                  </div>
                  <div className='col-md-6 mb-3'>
                    <CustomTextField
                      item={formData.itemId}
                      handleInputChange={(e) => {
                        setFormData({ itemId: e });
                      }}
                      maxLength='30'
                      multiline={true}
                      endAdornment={true}
                      characterCount={true}
                    />
                  </div>
                </div>
                <div className='row'>
                  <div className='col-md-12 mb-3'>
                    <CustomTextField
                      item={formData.itemDescription}
                      handleInputChange={(e) => {
                        setFormData({ itemDescription: e });
                      }}
                      multiline={true}
                    />
                  </div>
                </div>
                <div className='row'>
                  <div className='col-md-6 mb-3'>
                    <CustomSelect
                      hideNullOption={false}
                      item={formData.itemDataType}
                      handleInputChange={(e) => {
                        setFormData({ itemDataType: e });
                      }}
                      options={ITEM_DATA_TYPE_OPTIONS}
                    />
                  </div>
                </div>
                <div className='col-md-12 mb-3'>
                  <div
                    className='d-flex align-items-center mt-1 '
                    onClick={(e) => e.stopPropagation()}
                  >
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={formData.itemActive.value}
                            onChange={(e) =>
                              setFormData({
                                itemActive: { ...formData.itemActive, value: e.target.checked },
                              })
                            }
                          />
                        }
                        label='Active'
                      />
                    </FormGroup>
                  </div>
                </div>
                <div className='col-md-6 mt-5'>
                  <div className='align-items-center'>
                    <h4 className='tab-title'>Max Quantity</h4>
                    <div className='d-flex justify-content-between'>
                      <FormControl>
                        <RadioGroup
                          row
                          aria-labelledby='demo-radio-buttons-group-label'
                          defaultValue={formData.itemQuantity.value}
                          value={formData.itemQuantity.value}
                          name='radio-buttons-group'
                          onChange={(e) => onItemQuantityChange(e)}
                        >
                          <FormControlLabel value='Active' control={<Radio />} label='Active' />
                          <FormControlLabel
                            value='Inactive'
                            control={<Radio className='radio' />}
                            label='Inactive'
                            className='ms-5'
                          />
                        </RadioGroup>
                      </FormControl>
                    </div>
                  </div>
                </div>
                {formData.itemQuantity.value === 'Active' && (
                  <>
                    <div className='row'>
                      <div className='col-md-6 '>
                        <CustomTextField
                          item={formData.itemMaxQuantity}
                          handleInputChange={(e) => {
                            setFormData({ itemMaxQuantity: e });
                          }}
                          type='number'
                          min={1}
                        />
                      </div>
                      {itemsError.quantity && (
                        <p className='field-error mt-2'>Quantity can't be less than 1*</p>
                      )}
                    </div>
                  </>
                )}
                <div className='mt-3 add-btn'>
                  {edit ? (
                    <>
                      <Button
                        variant='outlined'
                        color='primary'
                        onClick={() => onItemUpdate(itemIndex)}
                      >
                        Update
                      </Button>
                      <Button
                        variant='text'
                        color='secondary'
                        onClick={cancelEdit}
                        className='ms-2'
                      >
                        Cancel
                      </Button>
                    </>
                  ) : (
                    <Button
                      variant='outlined'
                      color='primary'
                      onClick={() => onItemAdd()}
                    >
                      Add
                    </Button>
                  )}
                </div>
                <div className='col-md-13 mt-3  item-list-container'>
                  <DragDropContext onDragEnd={(e) => onDragEnd(e)}>
                    <Droppable droppableId='droppableSpaContactInfo'>
                      {(provided, snapshot) => (
                        <div
                          {...provided.droppableProps}
                          className='col-md-11 px-1 py-1'
                          ref={provided.innerRef}
                        >
                          {itemList && itemList.length > 0
                            ? itemList.map((item, index) => (
                                <Draggable key={index} draggableId={'dragId' + index} index={index}>
                                  {(provided, snapshot) => (
                                    <div
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                      className='col row custom-duration-box'
                                    >
                                      <div className='d-flex align-items-center' key={index}>
                                        <IconButton
                                          aria-label='drag'
                                          disabled={true}
                                          style={{ padding: '8px' }}
                                        >
                                          <DragIndicatorIcon fontSize='large' />
                                        </IconButton>
                                        <div style={{ flex: '0 0 250px', marginRight: '12px' }}>
                                          <TextField
                                            label='Item Name'
                                            id='name'
                                            value={item.name}
                                            InputProps={{
                                              readOnly: true,
                                            }}
                                            fullWidth
                                          />
                                        </div>
                                        <div style={{ marginRight: '12px' }}>
                                          {item.maxQuantity && item.maxQuantity > 0 ? (
                                            <TextField
                                              label='Max Quantity'
                                              id='max quantity'
                                              value={item.maxQuantity}
                                              InputProps={{
                                                readOnly: true,
                                              }}
                                              style={{ width: '120px' }}
                                            />
                                          ) : (
                                            <TextField
                                              label='Max Quantity'
                                              id='max quantity'
                                              value='---'
                                              InputProps={{
                                                readOnly: true,
                                              }}
                                              style={{ width: '120px' }}
                                            />
                                          )}
                                        </div>
                                         <div style={{ marginRight: '12px' }}>
                                          {item.itemDataType ? (
                                            <TextField
                                              label='Type'
                                              id='type'
                                              value={item.itemDataType.charAt(0).toUpperCase() + item.itemDataType.slice(1)}
                                              InputProps={{
                                                readOnly: true,
                                              }}
                                              style={{ width: '80px' }}
                                            />
                                          ) : (
                                            <TextField
                                              label='Type'
                                              id='type'
                                              value='---'
                                              InputProps={{
                                                readOnly: true,
                                              }}
                                              style={{ width: '80px' }}
                                            />
                                          )}
                                        </div>
                                        <div style={{ marginRight: '12px' }}>
                                          <CustomChip
                                            label={item.isActive ? 'Active' : 'Inactive'}
                                            color={item.isActive ? 'primary' : 'default'}
                                          />
                                        </div>
                                        <IconButton
                                          aria-label='edit'
                                          onClick={(e) => onItemEdit(e, index)}
                                          style={{ padding: '8px' }}
                                        >
                                          <EditIcon fontSize='small' className='icon' />
                                        </IconButton>
                                        <IconButton
                                          aria-label='delete'
                                          onClick={(e) => onDeleteItem(e, index)}
                                          style={{ padding: '8px' }}
                                        >
                                          <RemoveCircleIcon fontSize='small' className='icon' />
                                        </IconButton>
                                      </div>
                                    </div>
                                  )}
                                </Draggable>
                              ))
                            : null}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>
                </div>
              </div>
            )}
          </div>
        )}
        {tabValue === 2 && (
          <div className='row px-3 w-100 d-flex mt-4 overflow-auto'>
            <div className='col-md-10 mt-3'>
              <div className='align-items-center'>
                <h4 className='tab-title'>Available On</h4>
                <div className='d-flex justify-content-between mt-2'>
                  <FormControl>
                    <RadioGroup
                      row
                      aria-labelledby='demo-radio-buttons-group-label'
                      defaultValue={formData.availableOn.value}
                      value={formData.availableOn.value}
                      name='radio-buttons-group'
                      onChange={(e) => {
                        onChangeAvailableOn(e);
                      }}
                    >
                      <FormControlLabel value='EveryDay' control={<Radio />} label='EveryDay' />
                      <FormControlLabel
                        value='Custom'
                        control={<Radio className='radio' />}
                        label='Custom'
                        className='ms-5'
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
              </div>
            </div>
            {formData.availableOn.value === 'Custom' && (
              <div>
                <div className='d-flex justify-content-between  mt-2 '>
                  <FormControlLabel
                    control={
                      <Checkbox
                        className='check-box'
                        checked={formData.days.monday}
                        onChange={(e) => onDaysCheckChange(e, 'monday')}
                      />
                    }
                    label='Monday'
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        className='check-box'
                        checked={formData.days.tuesday}
                        onChange={(e) => onDaysCheckChange(e, 'tuesday')}
                      />
                    }
                    label='Tuesday'
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        className='check-box'
                        checked={formData.days.wednesday}
                        onChange={(e) => onDaysCheckChange(e, 'wednesday')}
                      />
                    }
                    label='Wednesday'
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        className='check-box'
                        checked={formData.days.thursday}
                        onChange={(e) => onDaysCheckChange(e, 'thursday')}
                      />
                    }
                    label='Thursday'
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        className='check-box'
                        checked={formData.days.friday}
                        onChange={(e) => onDaysCheckChange(e, 'friday')}
                      />
                    }
                    label='Friday'
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        className='check-box'
                        checked={formData.days.saturday}
                        onChange={(e) => onDaysCheckChange(e, 'saturday')}
                      />
                    }
                    label='Saturday'
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        className='check-box'
                        checked={formData.days.sunday}
                        onChange={(e) => onDaysCheckChange(e, 'sunday')}
                      />
                    }
                    label='Sunday'
                  />
                </div>
              </div>
            )}
            <div className='col-md-6 mt-5'>
              <div className='align-items-center'>
                <h4 className='tab-title'>Hours</h4>
                <div className='d-flex justify-content-between mt-3'>
                  <FormControl>
                    <RadioGroup
                      row
                      aria-labelledby='demo-radio-buttons-group-label'
                      defaultValue={formData.hours.value}
                      value={formData.hours.value}
                      name='radio-buttons-group'
                      onChange={(e) => onChangeHours(e)}
                    >
                      <FormControlLabel value='EveryDay' control={<Radio />} label='24 * 7' />
                      <FormControlLabel
                        value='Custom'
                        control={<Radio className='radio' />}
                        label='Custom'
                        className='ms-5'
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
              </div>
            </div>
            {formData.hours.value === 'Custom' && (
              <div className='row'>
                <div className='row'>
                  <div className='col-md-6'>
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                      <KeyboardTimePicker
                        variant='inline'
                        margin='normal'
                        id='from'
                        label='From'
                        className='col-md-12'
                        ampm={false}
                        format='HH:mm'
                        inputValue={formData?.from?.value}
                        onChange={(date, value) => handleTimeChange(date, value, 'from')}
                        error={hoursError.fromError}
                        helperText={hoursError.fromError ? hoursError.fromMessage : ''}
                        keyboardIcon={<WatchLaterIcon />}
                      />
                    </MuiPickersUtilsProvider>
                  </div>
                  <div className='col-md-6'>
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                      <KeyboardTimePicker
                        variant='inline'
                        margin='normal'
                        id='to'
                        label='To'
                        className='col-md-12'
                        ampm={false}
                        format='HH:mm'
                        inputValue={formData?.to?.value}
                        onChange={(date, value) => handleTimeChange(date, value, 'to')}
                        error={hoursError.toError}
                        helperText={hoursError.toError ? hoursError.toMessage : ''}
                        keyboardIcon={<WatchLaterIcon />}
                      />
                    </MuiPickersUtilsProvider>
                  </div>
                </div>
              </div>
            )}
            <div className='mt-2 add-btn'>
              {!hoursEdit ? (
                <Button
                  style={{ width: '100px' }}
                  variant='outlined'
                  type='button'
                  color='primary'
                  onClick={() => onHourAdd()}
                >
                  Add
                </Button>
              ) : (
                <Button
                  style={{ width: '100px' }}
                  variant='outlined'
                  type='button'
                  color='primary'
                  onClick={() => onUpdateHours(hourIndex)}
                >
                  Edit
                </Button>
              )}
              {hoursError?.days && <p className='field-error'>Please select days first</p>}
              {formData?.hours?.value === 'Custom' &&
                hoursError?.submit &&
                hoursError?.time &&
                formData?.days?.value?.length === 1 && (
                  <p className='field-error mt-2'>{hoursError?.timeMessage}</p>
                )}{' '}
              {hoursError?.duplicate && (
                <p className='field-error mt-2'>
                  Same day with same time already added, Please change time
                </p>
              )}
              {hoursError?.allDayTime && (
                <p className='field-error mt-2'>Please remove current timing first</p>
              )}
            </div>
            <div className='col-9 col-md-9 mt-3 item-list-container'>
              {hourList && hourList?.length > 0
                ? hourList?.map(
                    (item, index) =>
                      (item?.allTime || (item?.open && item?.close)) && (
                        <div
                          className='row custom-daytime-box mt-2 mx-2 align-items-center'
                          key={index}
                        >
                          <div className='col-md-3'>
                            {item.everyday
                              ? 'Everyday'
                              : item?.day
                                  .map(
                                    (d) =>
                                      d.substr(0, 3).charAt(0).toUpperCase() +
                                      d.substr(1, 2).toLowerCase(),
                                  )
                                  .join(', ')}
                          </div>
                          <div className='col-md-4 text'>
                            {item.allTime ? 'all day - all day' : item.open + ' - ' + item.close}
                          </div>
                          <div className='col-md-3 ms-4'>
                            <IconButton
                              aria-label='edit'
                              onClick={(e) => onHoursEdit(e, index, item.day)}
                              disabled={isEdit}
                            >
                              <EditIcon fontSize='12' className='icon' />
                            </IconButton>
                            <IconButton aria-label='delete' onClick={(e) => onDeleteHour(e, index)}>
                              <RemoveCircleIcon fontSize='large' className='icon' />
                            </IconButton>
                          </div>
                        </div>
                      ),
                  )
                : null}
            </div>
          </div>
        )}
        {tabValue === 3 && (
          <div className='row px-3 w-100 d-flex mt-4 overflow-auto'>
            <div className='col-md-12 mb-3'>
              <h4 className='tab-title '>Media</h4>
              <ImageUpload
                uploadedImages={formData.images.value}
                imgList={rawImages}
                onImageListUpdated={onImageListUpdated}
                onUploadedImageRemoval={onUploadedImageRemoval}
                onImagesLoading={(status) => {
                  setLoading(status);
                }}
                videoImageUrl={videoImageUrl}
                onVideoImageUrlChange={setVideoImageUrl}
                gifImageUrl={gifImageUrl}
                onGifImageUrlChange={setGifImageUrl}
                videoList={rawVideos}
                gifList={rawGifs}
                onVideoListUpdated={setRawVideos}
                onGifListUpdated={setRawGifs}
                hotelId={hotelId}
                groupId={groupId}
                propertyType={HOUSEKEEPING_TYPE}
                onVideoError={setHasVideoError}
                onThumbnailUploading={setIsThumbnailUploading}
                onVideoLoading={setIsVideoLoading}
                onGifLoading={setIsGifLoading}
              />
            </div>
          </div>
        )}
        <div className='row mx-2 mt-auto px-4 w-100 pb-5'>
          <div className='col-md-12 d-flex justify-content-start'>
            {tabValue < 3 ? (
              <Button
                variant='contained'
                color='primary'
                onClick={onNextClick}
                size='large'
                className='me-3'
                disabled={
                  hasVideoError ||
                  isThumbnailUploading ||
                  isVideoLoading ||
                  isGifLoading ||
                  (tabValue === 0
                    ? isTabInValid || !isScheduleSelectionValid() || !isMaxQtyValid
                    : tabValue === 1
                    ? (formData?.isItemActive?.value === 'Active' && itemList?.length === 0) || edit
                    : isTabInValid || (tabValue === 2 && hourList?.length === 0))
                }
              >
                Next
              </Button>
            ) : (
              <Button
                disabled={
                  loading || hasVideoError || isThumbnailUploading || isVideoLoading || isGifLoading
                }
                onClick={handleSubmit}
                variant='contained'
                color='primary'
                className='me-3'
                size='large'
              >
                {obj ? 'Update' : 'Add'}
              </Button>
            )}
            <Button
              disabled={loading}
              variant='outlined'
              type='button'
              color='secondary'
              size='large'
              onClick={(e) => onCancel(e)}
            >
              Cancel
            </Button>
          </div>
          {loading && <div className='pt-4 col-md-12'>{<LinearProgressBar />}</div>}
        </div>
      </div>
    </div>
  );
};

export default ConciergeCreate;
